module.exports = __webpack_public_path__ + "media/images/map-icons/carA-9ad9482cf6484ac08035ce5843a72ba1.png";